import React from "react";
import { prop, sortBy } from "ramda";
import { General } from "../../../../lib/types";
import GeneralSkillIcon from "./GeneralSkillIcon";
import { GENERAL_TYPE, systemClass } from "../../../../lib/enums";
import { isExclusiveUltimateActive, isUltimateTierAvailable } from "../../../../lib/commonFunctions";

interface IProps {
  general: General;
  generalTypeId: number;
  tier: number;
  strengthBonus: number;
}

const LevelTree = ({
  general,
  generalTypeId,
  tier,
  strengthBonus
}: IProps) => {
  const skills = sortBy(prop("qualityOrder"), general.skills.filter(skill => skill.tier === tier));
  const investedPoints = general.skills
    .reduce((level: number, skill) => level += (skill.tier !== 4 ? skill.level : 0), 0);
  const tierAvailable = (tier === 1 && (investedPoints < 4
    || (general.strengthBonus[Math.floor(investedPoints / 4) - 1]
      && !!general.strengthBonus[Math.floor(investedPoints / 4) - 1].bonus)))
    || (tier > 1 && (tier < 4
      ? !!(Math.floor(investedPoints
        / (4 * (tier - 1))) > 0
        && general.strengthBonus[Math.floor(investedPoints / 4) - 1]
        && general.strengthBonus[Math.floor(investedPoints / 4) - 1].bonus)
      : isUltimateTierAvailable(general)));
  const strengthBonusAvailable = !strengthBonus
    && !!general.skillPoints && investedPoints >= 4 * tier;

  return (
    <div className="col-sm-6 col-md-3">
      <div className={`person ${systemClass.MatchHeight}`} style={{ height: "616" }}>
        <p><h3 className="name">{tier > 3 ? "Ultimate" : `Tier ${tier}`}</h3></p>
        <div className="points-box">
          <div className="justify-content-container">
            <GeneralSkillIcon
              general={general}
              skill={skills[0]}
              available={tierAvailable && ((tier < 4 && general.skillPoints > 0)
                || (tier === 4 && isUltimateTierAvailable(general)
                  && !isExclusiveUltimateActive(general, skills[0])))}
              clickable={true}
            />
            <GeneralSkillIcon
              general={general}
              skill={skills[1]}
              available={tierAvailable && ((tier < 4 && general.skillPoints > 0)
                || (tier === 4 && isUltimateTierAvailable(general)
                  && !isExclusiveUltimateActive(general, skills[1])))}
              clickable={true}
            />
          </div>
          <div className="justify-content-container">
            <GeneralSkillIcon
              general={general}
              skill={skills[2]}
              available={tierAvailable && ((tier < 4 && general.skillPoints > 0)
                || (tier === 4 && isUltimateTierAvailable(general)
                  && !isExclusiveUltimateActive(general, skills[2])))}
              clickable={true}
            />
            <GeneralSkillIcon
              general={general}
              skill={skills[3]}
              available={tierAvailable && ((tier < 4 && general.skillPoints > 0)
                || (tier === 4 && isUltimateTierAvailable(general)
                  && !isExclusiveUltimateActive(general, skills[3])))}
              clickable={true}
            />
          </div>
          <span className={`arrow progress${Math.min(investedPoints - 4 * (tier - 1), 4)}`}/>
        </div>
        <span className="divider"/>
        <div className={"text-center"}>
          <p><h3 className="name">Strength bonus</h3></p>
          <p className={"points-box"}>
            <GeneralSkillIcon
              general={general}
              tier={tier}
              economist={generalTypeId === GENERAL_TYPE.ECONOMIST}
              strengthBonusLevel={strengthBonus ? 1 : 0}
              available={strengthBonusAvailable}
              clickable={!strengthBonus}
            />
          </p>
          {strengthBonus
            ? generalTypeId === GENERAL_TYPE.ECONOMIST
              ? <p>+5 <i className={"icon icon-pozemky middle"}/></p>
              : strengthBonus === 3
                ? <p>+1 ATT & DEF</p>
                : <p>+2 {strengthBonus === 1 ? "ATT" : "DEF"}</p>
            : null
          }
        </div>
      </div>
    </div>
  );
}

export default LevelTree;
